// Libraries
import { Flex, Text } from '@chakra-ui/react';
// Types
import { GenericHeaderProps } from './GenericHeader.type';

/**
 * The `GenericHeader` component displays a generic header with a subtitle and tag.
 *
 * @component
 * @param {GenericHeaderProps} props - The component props.
 * @param {string} props.title - The title displayed in the header.
 * @param {string} props.titleTag - The tag associated with the title.
 * @param {string} props.subTitle - The subtitle displayed below the title.
 * @returns {ReactElement} - The `GenericHeader` component.
 */
export const GenericHeader = ({ title, titleTag, subTitle }: GenericHeaderProps) => (
  <Flex flexDir='column'>
    <Flex columnGap={2}>
      <Text fontSize='md' fontWeight='bold'>
        {title}
      </Text>
      {!!titleTag && <Text fontSize='l'>({titleTag})</Text>}
    </Flex>
    {!!subTitle && (
      <Text variant='faded' fontSize='s'>
        {subTitle}
      </Text>
    )}
  </Flex>
);
